<opac-dialog
  [size]="'large'"
  [title]="'lists.coverSelect' | translate"
  (closed)="closeDialog()"
>
  <div *ngIf="list()" class="container" [opac-radio-group]="'covers'">
    <!-- Show custom cover and increment index in the rest of items -->
    <ng-container *ngIf="list().customCoverUrl">
      <div
        class="cover"
        [opacRadioElement]="'covers'"
        [checked]="selectedCoverIdx() === 0"
        (change)="selectedCoverIdx.set(0)"
      >
        <opac-record-cover [coverUrl]="list()?.customCoverUrl" [showIcon]="false"></opac-record-cover>
      </div>

      <div
        *ngFor="let item of list().items; let index = index;"
        class="cover"
        [opacRadioElement]="'covers'"
        [checked]="(index + 1) === selectedCoverIdx()"
        (change)="selectedCoverIdx.set(index + 1)"
      >
        <opac-record-cover [coverUrl]="item.coverUrl" [showIcon]="false"></opac-record-cover>
      </div>
    </ng-container>

    <!-- Without custom cover just loop through items -->
    <ng-container *ngIf="!list().customCoverUrl">
      <div
        *ngFor="let item of list().items; let index = index;"
        class="cover"
        [opacRadioElement]="'covers'"
        [checked]="index === selectedCoverIdx()"
        (change)="selectedCoverIdx.set(index)"
      >
        <opac-record-cover [coverUrl]="item.coverUrl" [showIcon]="false"></opac-record-cover>
      </div>
    </ng-container>
  </div>

  <div class="actions" slot="actions">
    <opac-button (click)="saveCover()">
      {{ 'general.save' | translate }}
    </opac-button>

    <opac-button [type]="'secondary'" (click)="closeDialog()">
      {{ 'general.cancel' | translate }}
    </opac-button>
  </div>
</opac-dialog>
